<div class="blotter_table_target" #tableTarget>
  <ag-grid-angular
    style="width: 100%; height: 100%"
    class="ag-bcdfx pinned-border"
    [frameworkComponents]="frameworkComponents"
    [columnDefs]="columnDefs"
    [gridOptions]="gridOptions"
    [toolPanelSuppressSideButtons]="true"
    enableColResize
    multiSortKey="ctrl"
    (sortChanged)="sortChanged($event)"
    (mouseup)="onMouseUp($event)"
    (contextmenu)="handleClick($event)"
    [ngClass]="{'intentStyled': isIntentStyled === true, 'fullTempStyled': isFullTempStyle === true}"
  >
  </ag-grid-angular>
</div>
<bmark-fwd-risk-context-menu [currentLadderBlotter]="blotterInstance" bfxElementOnBody>
</bmark-fwd-risk-context-menu>
<bfx-blotter-column-selector [currentLadderBlotter]="blotterInstance" bfxElementOnBody>
</bfx-blotter-column-selector>
